/**
 * Platform entitlement vocabulary (COS-4844). CentsBE owns the contract —
 * `src/constants/entitlements/vocabulary.ts` — so these mirror it rather than define it.
 */
export const ENTITLEMENT_SLUGS = {
  CONNECT: 'connect',
  LAUNDROWORKS: 'laundroworks',
} as const;

/**
 * In Phase 1 each package holds exactly one slug of the same name. Granting `laundroworks` does not
 * grant `connect`, so never add one automatically alongside the other. A store may still hold both
 * when both were purchased.
 */
export const ENTITLEMENT_PACKAGE_KEYS = {
  CONNECT: 'connect',
  LAUNDROWORKS: 'laundroworks',
} as const;

export const ENTITLEMENT_LABELS = {
  [ENTITLEMENT_SLUGS.CONNECT]: 'Connect',
  [ENTITLEMENT_SLUGS.LAUNDROWORKS]: 'LaundroWorks',
} as const;

export const ENTITLEMENT_SOURCES = {
  ENTITLEMENTS: 'entitlements',
  FALLBACK: 'fallback',
} as const;

export const ENTITLEMENT_ACTIONS = {
  GRANT: 'grant',
  REVOKE: 'revoke',
} as const;

/** Mirrors the CentsBE schema: a reason is required, trimmed, and at most 500 characters. */
export const ENTITLEMENT_REASON_MAX_LENGTH = 500;

/** What an audit-trail record did. Mirrors CentsBE `AUDIT_ACTION_TYPES`. */
export const AUDIT_ACTION_TYPES = {
  GRANT: 'grant',
  REVOKE: 'revoke',
} as const;

export const AUDIT_ACTION_LABELS = {
  [AUDIT_ACTION_TYPES.GRANT]: 'Granted',
  [AUDIT_ACTION_TYPES.REVOKE]: 'Revoked',
} as const;

/** Who caused an audit-trail record. Mirrors CentsBE `AUDIT_ORIGINS`. */
export const AUDIT_ORIGINS = {
  SYSTEM: 'system',
  INTERNAL_MANAGER: 'internal_manager',
} as const;

export const AUDIT_ORIGIN_LABELS = {
  [AUDIT_ORIGINS.SYSTEM]: 'System',
  [AUDIT_ORIGINS.INTERNAL_MANAGER]: 'Internal Manager',
} as const;

/** CentsBE answers 50 records a page and reports only whether more remain (COS-4953). */
export const AUDIT_TRAIL_PAGE_SIZE = 50;
